import React, { useState } from 'react'
import { Grid, Button, ButtonGroup } from '@mui/material'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import IntlMessages from '../../../../util/IntlMessages'
import * as constants from '../../../../constants'
import RecordLiterature from './record_literature'
import ReachedOrigin from './reached_origin'
import EndRefueling from './end_refueling'
import useStyles from './styles'

function ButtonAction(props) {
    const classes = useStyles()

    const [refueling, setRefueling] = useState(false)
    const [endRefueling, setEndRefueling] = useState(false)
    const [reachedOrigin, setReachedOrigin] = useState(false)

    let requestDetails = props.field.requestOnline
    let { id } = useParams()
    let vRequestCode = id.replace(':id', '')

    const loadBtnFunc = () => {
        switch (requestDetails.iRequestStatus) {
            case constants.FUEL_REQUEST_ONLINE_OPERATOR_ON_WAY:
                return (
                    <Button
                        onClick={() => setReachedOrigin(!reachedOrigin)}
                        fullWidth
                        color="secondary"
                        variant="contained">
                        <IntlMessages id="iReachedRefuelingPoint" />
                    </Button>
                )
            case constants.FUEL_REQUEST_VOLUME_CONFIRM:
                return (
                    <ButtonGroup fullWidth>
                        <Button
                            onClick={() => setEndRefueling(!endRefueling)}
                            fullWidth
                            color="secondary"
                            size='large'
                            variant="contained">
                            <IntlMessages id="endRequest" />
                        </Button>
                        <Button
                            onClick={() => setRefueling(!refueling)}
                            fullWidth
                            size='large'
                            color="secondary"
                            variant="contained">
                            <IntlMessages id="recordLiterature" />
                        </Button>
                    </ButtonGroup>

                )
            case constants.FUEL_REQUEST_OPERATOR_REFUELING:
                return (
                    <Button
                        onClick={() => setRefueling(!refueling)}
                        fullWidth
                        color="secondary"
                        variant="contained">
                        <IntlMessages id="recordLiterature" />
                    </Button>
                )
            default:
                break
        }
    }

    return (
        <React.Fragment>
            <Grid className={classes.root}>
                {loadBtnFunc()}
            </Grid>
            <ReachedOrigin
                vRequestCode={vRequestCode}
                reachedOrigin={reachedOrigin}
                reachedOriginFunc={() => setReachedOrigin(!reachedOrigin)}
            />
            <EndRefueling
                vRequestCode={vRequestCode}
                endRefueling={endRefueling}
                iPaymentType={requestDetails.iPaymentType}
                setEndRefueling={() => setEndRefueling(!endRefueling)}
            />
            {refueling ?
                <RecordLiterature
                    vRequestCode={vRequestCode}
                    refueling={refueling}
                    setRefueling={() => setRefueling(!refueling)}
                /> : ''}
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    return {
        field: state.field,
    }
}

export default connect(mapStateToProps)(ButtonAction)